"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldServerSideRender = exports.setRenderOnTimeout = exports.isOnServer = exports.getClientSideRenderType = void 0;

var _DefermentType = _interopRequireDefault(require("./types/DefermentType"));

var _RenderMode = _interopRequireDefault(require("./types/RenderMode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Method to extract the client side deferment behavior from the superset of configuration states
 */
var getClientSideRenderType = function getClientSideRenderType(mode, isBot) {
  switch (mode) {
    case _RenderMode.default.RENDER_SERVER_SIDE_ONLY_NEVER_HYDRATE:
      return _DefermentType.default.NEVER_HYDRATE;

    case _RenderMode.default.RENDER_CLIENT_SIDE_INLINE_SLOW:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_INLINE_SLOW:
      return _DefermentType.default.HYDRATE_INLINE_SLOW;

    case _RenderMode.default.RENDER_CLIENT_SIDE_ON_VISIBLE:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE:
      return typeof IntersectionObserver !== 'undefined' ? _DefermentType.default.HYDRATE_ON_VISIBLE : _DefermentType.default.HYDRATE_ON_TIMER;

    case _RenderMode.default.RENDER_CLIENT_SIDE_ON_IMMEDIATE:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_ON_IMMEDIATE:
    case _RenderMode.default.RENDER_CLIENT_SIDE_ON_TIMER:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_ON_TIMER:
      return _DefermentType.default.HYDRATE_ON_TIMER;

    case _RenderMode.default.RENDER_FOR_BOTS_ONLY:
      return isBot ? _DefermentType.default.HYDRATE_INLINE_SLOW : _DefermentType.default.COMPLETE_SKIP;

    default:
      // eslint-disable-next-line no-console
      console.warn("getClientSideRenderType: Unrecognized render mode: " + mode);
      return _DefermentType.default.HYDRATE_INLINE_SLOW;
  }
};
/** Method to check if we're currently executing server-side */


exports.getClientSideRenderType = getClientSideRenderType;

var isOnServer = function isOnServer() {
  return typeof window === 'undefined';
};
/**
 * Utility method for setting up a timer callback to trigger full render
 *
 * @param stateFlagCallback Function to call when timeout expires
 * @param delay Delay of the timeout
 * @returns Timeout ID returned by `setTimeout`, or `-1` if currently being rendered server-side
 */


exports.isOnServer = isOnServer;

var setRenderOnTimeout = function setRenderOnTimeout(stateFlagCallback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  var isClientSideRender = !isOnServer();

  if (isClientSideRender) {
    return window.setTimeout(function () {
      stateFlagCallback(true);
    }, delay);
  }

  return -1;
};
/** Method to check if the server side logic should be active (else client side logic will be) */


exports.setRenderOnTimeout = setRenderOnTimeout;

var shouldServerSideRender = function shouldServerSideRender(mode, isBot) {
  if (isBot) {
    // If the current user agent identifies as a bot, we unconditionally render server side so
    // that we serve as much content and detail to the bot as possible. The first pass of the
    // bot does not execute rendering javascript so its important to server side render.
    return true;
  }

  switch (mode) {
    // List of total modes that render server side. Basically the ones prefixed in
    // RENDER_SERVER_SIDE.
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_INLINE_SLOW:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_ON_IMMEDIATE:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_ON_TIMER:
    case _RenderMode.default.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE:
    case _RenderMode.default.RENDER_SERVER_SIDE_ONLY_NEVER_HYDRATE:
      return true;

    case _RenderMode.default.RENDER_CLIENT_SIDE_INLINE_SLOW:
    case _RenderMode.default.RENDER_CLIENT_SIDE_ON_IMMEDIATE:
    case _RenderMode.default.RENDER_CLIENT_SIDE_ON_TIMER:
    case _RenderMode.default.RENDER_CLIENT_SIDE_ON_VISIBLE:
    case _RenderMode.default.RENDER_FOR_BOTS_ONLY:
      return false;

    default:
      // This switch lists all valid render modes to enforce good sync between modes enum and
      // shouldServerSideRender. If this warning is reached, there is likely a missing case
      // statement.
      // eslint-disable-next-line no-console
      console.warn("shouldServerSideRender: Unrecognized render mode: " + mode);
      return false;
  }
};

exports.shouldServerSideRender = shouldServerSideRender;